
    import ConfBase from "./ConfBase.vue"

    export default {
        name: "ConfRoschat",
        extends: ConfBase,
    }
